<template>
    <div class="max-w-[800px] mx-auto">
        <video controls>
            <source
                src="https://www.poslednik.de/wordpress/wp-content/themes/poslednik/assets/video/uber-poslednik.mp4"
                type="video/mp4"
            />
            Your browser does not support the video tag.
        </video>
    </div>
</template>
